import type { ParsedArgs } from '../args.js';
import { flag } from '../args.js';
import { CliError, ExitCode } from '../errors.js';
import type { CommandResult } from '../output.js';

const REPOSITORY_URL = 'https://github.com/ZaparooProject/zaparoo-cli';

export function feedbackCommand(args: ParsedArgs): CommandResult {
  const category = flag(args.flags, 'category') ?? 'bug';
  if (!['bug', 'skill', 'feature', 'security'].includes(category)) {
    throw new CliError('--category must be bug, skill, feature, or security', ExitCode.Usage);
  }
  const security = category === 'security';
  const url = security
    ? `${REPOSITORY_URL}/security/advisories/new`
    : issueUrl(category as 'bug' | 'skill' | 'feature');
  const checklist = [
    'Remove API keys, pairing material, PINs, auth tokens, and URL credentials.',
    'Remove private IP addresses, device IDs, account data, media paths, and token text.',
    'Review logs, traces, screenshots, and databases before sharing.',
    'Include CLI version, Core version, command path, policy, and structured error kind when safe.',
  ];
  return {
    data: {
      sent: false,
      category,
      url,
      public: !security,
      checklist,
      guidance: security
        ? 'Use private vulnerability reporting. Do not create a public issue.'
        : 'Review the checklist, then open the URL manually. CLI sends no telemetry.',
    },
    human: `${security ? 'Private security report' : 'Feedback'}: ${url}\n${checklist.map((item) => `- ${item}`).join('\n')}`,
  };
}

function issueUrl(category: 'bug' | 'skill' | 'feature'): string {
  const title =
    category === 'skill' ? '[Skill] ' : category === 'feature' ? '[Feature] ' : '[Bug] ';
  const labels = category === 'skill' ? 'agent-skills' : category;
  const query = new URLSearchParams({ title, labels });
  return `${REPOSITORY_URL}/issues/new?${query.toString()}`;
}
